<template>
  <div></div>
</template>

<script>
import FieldMixin from "./FieldMixin";
export default {
  mixins: [FieldMixin],
  name: "FieldUndefined",

  methods: {
    validate: function() {
      this.isValid = true;
    }
  }
};
</script>

